import React from "react";
import { FileText, FileCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const candidates = [{
  id: 1,
  surname: "Trivelloni",
  name: "Giuseppe",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/giuseppe-trivelloni-Cv-elezioni-2026.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/trivelloni.pdf",
  casellarioClassName: "p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px] text-center py-3"
}, {
  id: 2,
  surname: "Acitelli",
  name: "Arianna",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV_ARIANNA-Acitelli.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/acitelli.pdf"
}, {
  id: 3,
  surname: "Biondi",
  name: "Danila",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/BIONDI-DANILA-CV.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/biondi.pdf"
}, {
  id: 4,
  surname: "Bocchino",
  name: "Francesca",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/modello-cv-europeo.pdf_20260510_200532_0000.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/bocchino.pdf"
}, {
  id: 5,
  surname: "Bucciarelli",
  name: "Maria Luisa",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/BIONDI-DANILA-CV.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/borelli-2.pdf"
}, {
  id: 6,
  surname: "Ceci",
  name: "Mauro",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-Ceci-Mauro.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/ceci.pdf"
}, {
  id: 7,
  surname: "Cicchinelli",
  name: "Alessandro",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV_Alessandro_Cicchinelli.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/cicchinelli.pdf"
}, {
  id: 8,
  surname: "Cristea",
  name: "Ioana",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/C.V.-Ioana-Cristea-1.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/cristea.pdf"
}, {
  id: 9,
  surname: "De Magni",
  name: "Stefania",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/C.V.DE-MAGNI-STEFANIA.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/de-magni.pdf"
}, {
  id: 10,
  surname: "De Rossi",
  name: "Mauro",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-Mauro-De-Rossi-09-05-26-x-Candidatura-2026.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/de-rossi.pdf"
}, {
  id: 11,
  surname: "Duci",
  name: "Silvia",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-Gabriele-Engst.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/duci.pdf"
}, {
  id: 12,
  surname: "Engst",
  name: "Gabriele",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/curriculum-vitae-Francesco-Federici-2025.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/engst.pdf"
}, {
  id: 13,
  surname: "Federici",
  name: "Francesco",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/cv-vanessa-LI-PUMA-1.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/federici.pdf"
}, {
  id: 14,
  surname: "Li Puma",
  name: "Vanessa",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-Marinelli-EU.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/li-puma.pdf"
}, {
  id: 15,
  surname: "Mancini",
  name: "Virginio",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV_Gianluca_Mastrogiacomo_sintesi-1.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/mancini.pdf"
}, {
  id: 16,
  surname: "Marinelli",
  name: "Giorgia",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-Laura-Muzi.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/marinelli.pdf"
}, {
  id: 17,
  surname: "Mastrogiacomo",
  name: "Gianluca detto LUCA",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/cv_europeo-Persiani-Elena-1.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/mastrogiacomo.pdf"
}, {
  id: 18,
  surname: "Muzi",
  name: "Laura",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-FRANCESCA-PINTO-1-1.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/muzi.pdf"
}, {
  id: 19,
  surname: "Persiani",
  name: "Elena",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/Modello-CV-Europeo-Rapisardi-Mario.doc",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/persiani.pdf"
}, {
  id: 20,
  surname: "Pinto",
  name: "Francesca",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-Giorgio-Romani.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/pinto.pdf"
}, {
  id: 21,
  surname: "Rapisardi",
  name: "Mario",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/Curriculum-Sbordoni-Antonio.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/rapisardi.pdf"
}, {
  id: 22,
  surname: "Romani",
  name: "Giorgio",
  cv: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-Sara-Vitale.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/romani.pdf"
}, {
  id: 23,
  surname: "Sbordoni",
  name: "Antonio",
  cv: "#",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/sbordoni.pdf"
}, {
  id: 24,
  surname: "Vitale",
  name: "Sara",
  cv: "https://example.com/cv-vitale.pdf",
  casellario: "https://borellisindaco.it/wp-content/uploads/2026/05/vitale.pdf"
}, {
  id: 25,
  surname: "Zini",
  name: "Giulio",
  cv: "#",
  casellario: "#"
}];
export default function CandidatesList6() {
  return <section id="candidati-lista-6" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold font-default mb-4 text-foreground">Candidati Identita Bene Comune</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Elenco ufficiale dei candidati. In ottemperanza alle normative sulla trasparenza, sono disponibili per la consultazione i curriculum vitae e i certificati del casellario giudiziale di ciascun candidato.
          </p>
        </div>

        <div className="border border-border rounded-lg overflow-hidden shadow-sm bg-card">
          <Table>
            <TableHeader className="bg-muted/50 border-b border-border">
              <TableRow className="hover:bg-transparent">
                <TableHead className="w-full sm:w-[50%] font-semibold text-foreground py-4">
                  Cognome e Nome
                </TableHead>
                <TableHead className="text-center font-semibold text-foreground py-4 whitespace-nowrap">
                  Curriculum Vitae
                </TableHead>
                <TableHead className="text-center font-semibold text-foreground py-4 whitespace-nowrap">
                  Casellario Giudiziale
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {candidates.map((candidate, i) => <TableRow key={candidate.id} data-index={i} className={`transition-colors hover:bg-muted/50 ${i % 2 === 0 ? "bg-background" : "bg-muted/20"}`}>
                  <TableCell className="font-medium text-foreground py-3">
                    {candidate.surname} {candidate.name}
                  </TableCell>
                  <TableCell className="text-center py-3">
                    <Button variant="outline" size="sm" asChild className="h-8 w-full sm:w-auto">
                      <Link to={candidate.cv} download aria-label={`Scarica il file CV di ${candidate.name} ${candidate.surname}`}>
                        <FileText className="w-4 h-4 sm:mr-2" />
                        <span className="hidden sm:inline">Scarica CV</span>
                      </Link>
                    </Button>
                  </TableCell>
                  <TableCell className={`${candidate.casellarioClassName || ""} text-center py-3`}>
                    <Button variant="outline" size="sm" asChild className="h-8 w-full sm:w-auto">
                      <Link to={candidate.casellario} download aria-label={`Scarica il file casellario di ${candidate.name} ${candidate.surname}`}>
                        <FileCheck className="w-4 h-4 sm:mr-2" />
                        <span className="hidden sm:inline">Certificato</span>
                      </Link>
                    </Button>
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
      </div>
    </section>;
}